import { AbstractControl, ValidatorFn } from '@angular/forms';

export const ThisFieldIsRequiredMessage: string = 'This Field is required';

export function NotEmptyValidator(errorMessage: string = null): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    let value = control.value;
    let isNotEmpty = value;
    if (typeof value === 'string') {
      isNotEmpty = value.trim();
    } else if (typeof value === 'number') {
      isNotEmpty = !isNaN(Number(value));
    } else if (
      value &&
      typeof value === 'object' &&
      'controls' in value &&
      Array.isArray(value.controls)
    ) {
      isNotEmpty = value.controls.some(
        (control) => control.value && control.value.checked === true
      );
    } else if (value instanceof Array) {
      isNotEmpty = value.length > 0;
    }

    return isNotEmpty
      ? null
      : { notEmpty: errorMessage ? errorMessage : SetErrorMessage(GetControlName(control)) };
  };
}

export function SetErrorMessage(controlName: string): string {
  return controlName ? `${SplitControlName(controlName)} is required` : ThisFieldIsRequiredMessage;
}

export function GetControlName(control: AbstractControl): string {
  if (!control.parent || !control.parent.controls) {
    return null;
  }
  let formGroup = control.parent.controls;
  return Object.keys(formGroup).find((name) => control === formGroup[name]) || null;
}

export function SplitControlName(controlName: string): string {
  return controlName.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
}
